import React from 'react';
import { connect } from 'react-redux';
import {
  setDesign,
  setDesignType,
  setSafetyMinute,
  setSafetyFireAttack,
  setMaximumDeviationActive,
  setMaximumDeviationValue,
  setCheckProfileResistanceActive,
  setCladdingCombinations
} from '@reducers/selectors/design/actions';

import SelectWithOther from '../../../../components/SelectWithOther';

import { Row, Col } from 'reactstrap';
import Accordion from '@components/Accordion';
import AccordionItem from '@components/Accordion/components/AccordionItem';

import FixedAnchorageDepth from '../../../Design/components/GeneralCalculationDesign/FixedAnchorageDepth';
import { APP_TEXTS } from '../../../../texts/texts';
import { CalculationTypes as types } from '@reducers/selectors/design';
import { getDesignMethodName } from '../..';
import './styles.scss';
import { CladdingTypes } from '@object-generators/safety-barrier/objects/cladding';

const Method = props => (
  <Row>
    <Col sm="12">
      <div className="calculation method-tab">
        {/* {props.designStandard === standardList['EU'] && ( */}
          <section className="list-type">
            <label className={props.design === types.EN1992 ? '' : 'inactive'} htmlFor={types.EN1992}>
              <input
                id={types.EN1992}
                type="radio"
                name="calculationUsed" // use the same name for radio buttons
                onChange={(e) => {
                  props.setDesign(e.target.id);
                  if (props.designType !== types.EN1992_TYPE_ONE && props.designType !== types.EN1992_TYPE_TWO)
                    props.setDesignType(types.EN1992_TYPE_ONE);
                }}
                checked={props.design === types.EN1992}
              />
              <b>&nbsp;{getDesignMethodName(props.designStandard)}</b>
            </label>
            {/* {props.design === types.EN1992 && (
              <div className="ml-3">
                <label htmlFor={types.EN1992_TYPE_ONE} className="radio-group__item">
                  <input
                  id={types.EN1992_TYPE_ONE}
                  type="radio"
                  name="etagType"
                  onChange={(e) => {
                    props.setDesign(types.EN1992);
                    props.setDesignType(e.target.id);
                  }}
                  defaultChecked={props.designType === types.EN1992_TYPE_ONE}
                  />
                  {APP_TEXTS.METHOD_POST_INSTALLED_MECHANICAL_FASTENERS.Content}
                  </label>
                <label htmlFor={types.EN1992_TYPE_TWO} className="radio-group__item">
                  <input
                    id={types.EN1992_TYPE_TWO}
                    type="radio"
                    name="etagType"
                    onChange={(e) => {
                      props.setDesign(types.EN1992);
                      props.setDesignType(e.target.id);
                    }}
                    defaultChecked={props.designType === types.EN1992_TYPE_TWO}
                  />
                  {APP_TEXTS.METHOD_POST_INSTALLED_BONDED_FASTENERS.Content}
                </label>
              </div>
            )} */}
          </section>
        {/* )} */}
        {/* {props.designStandard !== standardList['EU'] && (
          <section className="list-type">
            <label className={props.design === types.ETAG ? '' : 'inactive'} htmlFor={types.ETAG}>
              <input
                id={types.ETAG}
                type="radio"
                name="calculationUsed" // use the same name for radio buttons
                onChange={(e) => props.setDesign(e.target.id)}
                defaultChecked={props.design === types.ETAG}
              />
              <b>&nbsp;<span className="text-uppercase">{APP_TEXTS.METHOD_ETAG.Content}</span>{APP_TEXTS.METHOD_CALCULATION.Content}</b>
            </label>
            <span>{APP_TEXTS.METHOD_A_DESIGN_RESISTANCE.Content}</span>
            <span>{APP_TEXTS.METHOD_ANNEX_C_ETA_GUIDANCE001.Content}</span>
            {props.design === types.ETAG &&
            <div className="ml-3">
              <label htmlFor={types.ETAG_TYPE_ONE} className="radio-group__item">
                <input
                  id={types.ETAG_TYPE_ONE}
                  type="radio"
                  name="etagType"
                  onChange={(e) => props.setDesignType(e.target.id)}
                  defaultChecked={props.designType === types.ETAG_TYPE_ONE}
                />
                {APP_TEXTS.METHOD_ULTIMATE_LIMIT.Content}
              </label>
              <label htmlFor={types.ETAG_TYPE_TWO} className="radio-group__item">
                <input
                  id={types.ETAG_TYPE_TWO}
                  type="radio"
                  name="etagType"
                  onChange={(e) => props.setDesignType(e.target.id)}
                  defaultChecked={props.designType === types.ETAG_TYPE_TWO}
                />
               {APP_TEXTS.METHOD_VARIABLE_ANCHORAGE_ADHESIVE_ANCHORS.Content} <br/>
                {APP_TEXTS.METHOD_CASE_NO_VALUE.Content}
              </label>
            </div>
            }
          </section>
        )}

        <section className="list-type">
          <label className={props.design === types.CEN ? '' : 'inactive'} htmlFor={types.CEN}>
            <input
              id={types.CEN}
              type="radio"
              name="calculationUsed" // use the same name for radio buttons
              onChange={(e) => props.setDesign(e.target.id)}
              defaultChecked={props.design === types.CEN}
            />
            <b>&nbsp;<span className="text-uppercase">cen/ts</span>{APP_TEXTS.METHOD_CALCULATION.Content}</b>
          </label>
          {props.design === types.CEN &&
            <div className="ml-3">
              <label htmlFor={props.CEN_TYPE_ONE} className="radio-group__item">
                <input
                  id={props.CEN_TYPE_ONE}
                  type="radio"
                  name="cenType"
                  onChange={(e) => props.setDesignType(e.target.id)}
                  defaultChecked={props.designType === types.CEN_TYPE_ONE}
                />
                {APP_TEXTS.METHOD_MECHANICAL_AND_ADHESIVE_ANCHORS.Content}
              </label>
              <label htmlFor={types.CEN_TYPE_TWO} className="radio-group__item">
                <input
                  id={types.CEN_TYPE_TWO}
                  type="radio"
                  name="cenType"
                  onChange={(e) => props.setDesignType(e.target.id)}
                  defaultChecked={props.designType === types.CEN_TYPE_TWO}
                />
                {APP_TEXTS.METHOD_CHEMICAL_ANCHORS.Content} <br />
                {APP_TEXTS.METHOD_CASE_NO_VALUE.Content}
              </label>
            </div>
          }
        </section> */}
{/* 
        <section className="list-type">
          <label className={props.design === types.FIRE ? '' : 'inactive'} htmlFor={types.FIRE}>
            <input
              id={types.FIRE}
              type="radio"
              name="calculationUsed" // use the same name for radio buttons
              onChange={(e) => props.setDesign(e.target.id)}
              defaultChecked={props.design === types.FIRE}
            />
            <b>
              &nbsp;
              <span className="text-uppercase">
                {APP_TEXTS.DESIGN_METHOD_FIRE.Content}
              </span>
              {APP_TEXTS.METHOD_CALCULATION.Content}
            </b>
          </label>
          <span>{APP_TEXTS.METHOD_FIRE_EXPOSURE.Content}.</span>

          {props.design === types.FIRE && (
            <React.Fragment>
              <label htmlFor="minute">
                <select
                  onChange={e => props.setSafetyMinute(e.target.value)}
                  id="minute"
                  name="minute"
                  className="form-control w-25 mr-2"
                >
                  <option value="30">30</option>
                </select>
                {APP_TEXTS.DESIGN_REBAR_MINUTE.Content}
              </label>

              <label htmlFor="fire_attay">
                <select
                  onChange={e => props.setSafetyFireAttack(e.target.value)}
                  id="fire_attay"
                  name="fire_attay"
                  className="form-control w-25 mr-2"
                >
                  <option value="one_side">{APP_TEXTS.SAFETY_BARRIER_ONE_SIDE.Content}</option>
                </select>
                {APP_TEXTS.SAFETY_BARRIER_FIRE_ATTACK.Content}
              </label>
          </React.Fragment>
          )}
        </section>

        <section className="list-type">
          <label className={props.design === types.SEISMIC ? '' : 'inactive'} htmlFor={types.SEISMIC}>
            <input
              id={types.SEISMIC}
              type="radio"
              name="calculationUsed" // use the same name for radio buttons
              onChange={(e) => {
                props.setDesign(e.target.id);
                if (props.designType !== types.SEISMIC_PERFORMANCE_CATEGORY_C1 && 
                    props.designType !== types.SEISMIC_PERFORMANCE_CATEGORY_C2)
                  props.setDesignType(types.SEISMIC_PERFORMANCE_CATEGORY_C1);
              }}
              defaultChecked={props.design === types.SEISMIC}
            />
            <b>&nbsp;{APP_TEXTS.METHOD_SEISMIC_CALCULATION.Content}</b>
          </label>
          <span>{APP_TEXTS.METHOD_SEISMIC_CALCULATION_DESCRIPTION.Content}</span>

          {props.design === types.SEISMIC && (
            <section className="list-type">
              <label htmlFor={types.SEISMIC_PERFORMANCE_CATEGORY_C1}>
                <input
                  id={types.SEISMIC_PERFORMANCE_CATEGORY_C1}
                  type="radio"
                  name="seismic_performance_category"
                  onChange={(e) => props.setDesignType(e.target.id)}
                  defaultChecked={props.designType === types.SEISMIC_PERFORMANCE_CATEGORY_C1}
                />
                <span>&nbsp;{APP_TEXTS.SEISMIC_PERFORMANCE_CATEGORY_C1.Content}</span>
              </label>

              <label htmlFor={types.SEISMIC_PERFORMANCE_CATEGORY_C2}>
                <input
                  id={types.SEISMIC_PERFORMANCE_CATEGORY_C2}
                  type="radio"
                  name="seismic_performance_category"
                  onChange={(e) => props.setDesignType(e.target.id)}
                  defaultChecked={props.designType === types.SEISMIC_PERFORMANCE_CATEGORY_C2}
                />
                <span>&nbsp;{APP_TEXTS.SEISMIC_PERFORMANCE_CATEGORY_C2.Content}</span>
              </label>
            </section>
          )}
        </section> */}
        {props.cladding !== CladdingTypes.None && (
          <section className='list-type'>
            <label htmlFor="cladding_combinations_1" className='d-inline-block mr-5'>
              <input
                id="cladding_combinations_1"
                type="checkbox"
                name="claddingCombinationFirstOption"
                onChange={e => 
                  props.setCladdingCombinations(e.target.checked, props.claddingCombinations && props.claddingCombinations.secondOption)
                }
                checked={props.claddingCombinations && props.claddingCombinations.firstOption}
              />
              <b>&nbsp;1,35.G + 1,5.Qh</b><br/>
              <b style={{ "margin-left": "13px" }}>&nbsp;1,35.G + 1,5.Qw</b>
            </label>
            
            <label htmlFor="cladding_combinations_2" className='d-inline-block'>
              <input
                id="cladding_combinations_2"
                type="checkbox"
                name="claddingCombinationSecondOption"
                onChange={e => 
                  props.setCladdingCombinations(props.claddingCombinations && props.claddingCombinations.firstOption, e.target.checked)
                }
                checked={props.claddingCombinations && props.claddingCombinations.secondOption}
              />
              <b>&nbsp;1,35.G + 1,5.Qh + 1,5.Yo.Qw</b><br/>
              <b style={{ "margin-left": "13px" }}>&nbsp;1,35.G + 1,5.Yo.Qh + 1,5.Qw</b>
            </label>
          </section>
        )}

        <section className="list-type">
          {/* <label className={false === types.CHECKBOXES ? '' : 'inactive'} htmlFor="checkboxes_1"> */}
          <label htmlFor="checkboxes_1">
            <input
              id="checkboxes_1"
              type="checkbox"
              name="etagOrCen"
              onChange={e => props.setCheckProfileResistanceActive(e.target.checked)}
              checked={props.checkProfileResistance}
            />
            <b>&nbsp;{APP_TEXTS.SAFETY_BARRIER_CHECK_PROFILE_RESISTANCE.Content}</b>
          </label>
          <span>{APP_TEXTS.SAFETY_BARRIER_CHECK_PROFILE_DESCRIPTION.Content}</span>

          {/* <label className={false === types.CHECKBOXES ? '' : 'inactive'} htmlFor="checkboxes_2"> */}
          {props.checkProfileResistance && (
            <label htmlFor="checkboxes_2" className="mt-2">
              <input
                id="checkboxes_2"
                type="checkbox"
                name="etagOrCen"
                onChange={e => props.setMaximumDeviationActive(e.target.checked)}
                checked={props.maximumDeviation.active}
              />
              <b>&nbsp;{APP_TEXTS.SAFETY_BARRIER_MAXIMUM_DEVIATION.Content}</b>
              <SelectWithOther
                className="MaximumDeviation"
                disabled={!props.maximumDeviation.active && "disabled"}
                onChange={props.setMaximumDeviationValue}
                options={[
                  { name: '1/100', value: 1/100 },
                  { name: '1/150', value: 1/150 }
                ].map(i => {
                  i.active = i.value === props.maximumDeviation.value;
                  return i;
                })}
              />
            </label>
          )}
        </section>
      </div>

      <Accordion className="application__accordion" appStatus={props.appStatus}>
        <AccordionItem id="fixed_anchorage_depth" title={APP_TEXTS.ANCHOR_DEPTH_TITLE.Content}>
          <FixedAnchorageDepth />
        </AccordionItem>
      </Accordion>

    </Col>
  </Row>
);

const mapState = state => ({
  design: state.selectors.design[state.main.appType].design,
  designType: state.selectors.design[state.main.appType].designType,
  checkProfileResistance: state.selectors.design[state.main.appType].checkProfileResistance,
  maximumDeviation: state.selectors.design[state.main.appType].maximumDeviation,
  designStandard: Number(state.main.localization.designStandard),
  cladding: state.selectors.application[state.main.appType].cladding,
  claddingCombinations: state.selectors.design[state.main.appType].claddingCombinations
});

const mapDispatch = {
  setDesign,
  setDesignType,
  setSafetyMinute,
  setSafetyFireAttack,
  setMaximumDeviationActive,
  setMaximumDeviationValue,
  setCheckProfileResistanceActive,
  setCladdingCombinations
};

export default connect(mapState, mapDispatch)(Method);



// WEBPACK FOOTER //
// ./src/views/Design/components/SafetyBarrierMethod/index.js